import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { lastValueFrom, map, take } from 'rxjs';
import { LoginService } from '../services/login.service';

@Injectable({providedIn: 'root'})
export class AuthGuard  {
    constructor(private loginService: LoginService, private router: Router) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const res = await lastValueFrom( this.loginService.authState.pipe(take(1)) );
        return res || this.router.createUrlTree(['/']);
    }
}
